import React from 'react';
import { Shield, Heart, Award } from 'lucide-react';
import Card3D from '../ui/Card3D';
import { colors } from '../../styles/theme';

const values = [
  {
    icon: <Shield className="w-8 h-8" />,
    title: "Commitment",
    description: "A strong commitment to equal opportunities and digital inclusion"
  },
  {
    icon: <Heart className="w-8 h-8" />,
    title: "Solidarity",
    description: "A supportive community that helps each other and shares knowledge"
  },
  {
    icon: <Award className="w-8 h-8" />,
    title: "Excellence",
    description: "Constant pursuit of excellence in our services and actions"
  }
];

const ValuesSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-16">Our Values</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <Card3D key={index}>
              <div className="bg-white p-8 rounded-2xl shadow-lg h-full">
                <div 
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                  style={{
                    backgroundColor: `${colors.primary}15`,
                    color: colors.primary
                  }}
                >
                  {value.icon}
                </div>
                <h3 
                  className="text-xl font-bold mb-4"
                  style={{ color: colors.primary }}
                >
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            </Card3D>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;